// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
//
// A requestAnimationFrame tween with ease-out, used by rui_chart for updates and
// the timeline. `raf` and `now` are injectable so tests can drive it by hand.

export const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

// Runs frame(progress) from 0 to 1 over `ms`, then done(). Returns cancel().
export function tween(ms, frame, done, { raf = (fn) => requestAnimationFrame(fn), cancel = (id) => cancelAnimationFrame(id), now = () => performance.now(), ease = easeOutCubic } = {}) {
  const start = now()
  let id = null
  let stopped = false
  const tick = () => {
    if (stopped) return
    const t = ms <= 0 ? 1 : Math.min(1, (now() - start) / ms)
    frame(ease(t))
    if (t < 1) {
      id = raf(tick)
    } else {
      id = null
      done && done()
    }
  }
  id = raf(tick)
  return () => {
    stopped = true
    if (id !== null) cancel(id)
    id = null
  }
}
